import axios from 'axios';
import {setViewportItemLastStateVisibility, setViewportItemTrajectoryVisibility,
        setViewportItemChartVisibility, SET_VIEWPORT_ITEM_AUTO_REFRESH,
        fetchViewportItemBasicInfo }
        from './viewportItemActions'
import {START_TIMER, SET_TIMER_CONSTANT, SET_TIMER_VISIBILITY} from './uiActions'

export const FETCH_VIEWPORT_REQUEST = 'FETCH_VIEWPORT_REQUEST';
export const FETCH_VIEWPORT_SUCCESS = 'FETCH_VIEWPORT_SUCCESS';
export const FETCH_VIEWPORT_ERROR = 'FETCH_VIEWPORT_ERROR';
// viewportId, urlParamsShow
//export const INIT_VIEWPORT = 'INIT_VIEWPORT'

// notes
export const SET_VIEWPORT_NOTES = 'SET_VIEWPORT_NOTES';
export const SET_VIEWPORT_ITEM_NOTES = 'SET_VIEWPORT_ITEM_NOTES';

// viewport's extra map features 
export const SET_EXTRA_MAP_FEATURES = 'SET_EXTRA_MAP_FEATURES';

// layerId -> feature (feature coordinates are keys for a layerId)
export const ADD_MAP_MARKER_FEATURE = 'ADD_MAP_MARKER_FEATURE';
export const REMOVE_MAP_MARKER_FEATURE = 'REMOVE_MAP_MARKER_FEATURE';

// index, visibility: false/true
export const SET_EXTRA_MAP_FEATURES_VISIBILITY = 'SET_EXTRA_MAP_FEATURES_VISIBILITY'

// URL parameters
export const APPLY_URL_PARAMS = 'APPLY_URL_PARAMS';


/* fetch viewport and viewport item data */
export function fetchViewport(viewportId, subview=null, initial=false) {
  return (dispatch, getState) => {
    const state = getState();
    const apiURL = state.ui.apiURL
    const jsonURL = state.ui.jsonURL

    dispatch({
      type: FETCH_VIEWPORT_REQUEST,
      viewportId: viewportId
    })

    //axios.get(`${apiURL}/viewport/${viewportId}/?desc=false`)
    return axios.get(`${apiURL}/viewport/${viewportId}/?desc=true`)
      .then( response => {
        //console.log("Viewport initializing.")
        var timeout = state.ui.viewportTimeout ;
        // drop previous timeout
        clearTimeout(timeout);

        // schedule next fetch:
        var viewportConfig = JSON.parse(response.data.config)
        var updateFreqSec = viewportConfig.updateFreqSec
        if (! updateFreqSec) updateFreqSec = 600
        var itemDefaultUpdateFreqSec = viewportConfig.itemDefaultUpdateFreqSec

        if (updateFreqSec > 0) {
          timeout = setTimeout( () => {
            dispatch( fetchViewport(viewportId, subview, false) )
          }, updateFreqSec*1000);
        }
        // fetching viewport successful
        dispatch( {
          type: FETCH_VIEWPORT_SUCCESS,
          response: response,
          timeout: timeout
        })

        // set up items:
        for (var item of response.data.items) {
          let conf = JSON.parse(item.config)
          var autoRefresh = false
          var lastStateVisible = false
          var trajectoryVisible = false
          var chartVisible = false
          var hidden = false
          var layerId = 't-default'
          var updateFreqSec = 20
          var key = null
          if (itemDefaultUpdateFreqSec) updateFreqSec = itemDefaultUpdateFreqSec
          if (conf) {
            lastStateVisible = conf.lastStateVisible
            trajectoryVisible = conf.trajectoryVisible
            chartVisible = conf.chartVisible
            if (conf.hidden) hidden = conf.hidden
            if (conf.layerId) layerId = conf.layerId
            autoRefresh = conf.autoRefresh
            if (conf.updateFreqSec) updateFreqSec = conf.updateFreqSec
            key = conf.key
          }
          
          if (subview) {
            if (conf.key===subview) {
              lastStateVisible = true
              trajectoryVisible = true
            }            
            else {
              lastStateVisible = false
              trajectoryVisible = false
            }
          }
          //console.log(item.viewport_item_id, ", ", conf.key, " --> ", lastStateVisible, trajectoryVisible)
          dispatch( {
            type: SET_VIEWPORT_ITEM_AUTO_REFRESH,
            viewportItemId: item.viewport_item_id,
            autoRefresh: autoRefresh,
            updateFreqSec: updateFreqSec
          } )
          dispatch( setViewportItemLastStateVisibility(item.viewport_item_id,
            lastStateVisible, true) )
          dispatch( setViewportItemTrajectoryVisibility(item.viewport_item_id,
            trajectoryVisible, true) )
          dispatch( setViewportItemChartVisibility(item.viewport_item_id,
              chartVisible, true) )
          dispatch( fetchViewportItemBasicInfo(item.viewport_item_id,
              true) )              
        }
        // set up timer:
        if (! viewportConfig.timer) {
          // if no timer config was provided:
          dispatch( {
            type: SET_TIMER_VISIBILITY,
            visibility: 'hidden'
          } )
        }
        else if ( viewportConfig.timer.constant ) {
          dispatch( {
            type: SET_TIMER_CONSTANT,
            visibility: ( viewportConfig.timer.visibility ?? 'hidden'),
            constant: viewportConfig.timer.constant
          } )
        }
        else {
          dispatch( {
            type: START_TIMER,
            visibility: ( viewportConfig.timer.visibility ?? 'hidden'),
            zero: viewportConfig.timer.zero
          } )
        }
        // TODO: notes turned off 
        // fetch viewport notes (server side json)
        //if (jsonURL) {
        //  axios.get(`${jsonURL}/viewport-notes.json`)
        //  .then( response => {
        //    dispatch( {
        //      type: SET_VIEWPORT_NOTES,
        //      notes: response.data.notes
        //    } )
        //  })
        //  .catch( error => {
        //    console.log(error)
        //  })
        //}

     
        //console.log("Viewport initialized.")
      })
      .catch( error => {
        dispatch({
          type: FETCH_VIEWPORT_ERROR,
          error: error
        })
      })
  }
}

/* urlParamShow: null, or contains viewport item config with sort keys to be displayed
   initially */
export function applyUrlParams(show) {
  return (dispatch, getState) => {
    // if the parameter show is provided, make the item(s) with the key(s) visible, and hide all the others
    if (show) {
      for (var itemId in getState().ui.viewportItemConfigs) {
        var key = getState().ui.viewportItemConfigs[itemId].key
        var visible = false
        if (show.includes(key)) visible = true
        dispatch( setViewportItemLastStateVisibility(itemId, visible, false) )
        dispatch( setViewportItemTrajectoryVisibility(itemId, visible, false) )
      }

    }

  }
}
